import {Injectable} from "@angular/core";
import {Helper, TreeComponent} from "@fgpp-ui/components";

@Injectable()
export class LinkedTreeService {
  private leftTree: TreeComponent;
  private rightTree: TreeComponent;

  bindTrees(leftTree: TreeComponent, rightTree: TreeComponent) {
    if (!leftTree || !rightTree) {
      console.error('Please provide valid references to left and right tree component');
    } else {
      this.leftTree = leftTree;
      this.rightTree = rightTree;
    }
  }

  moveAllToLeft(): void {
    this.rightTree.selectAll();
    this.doMoveLeft();
    this.refreshTrees();
    this.rightTree.unselectAll();
    this.leftTree.collapseAll();
  }

  moveToLeft(): void {
    this.doMoveLeft();
    this.refreshTrees();
  }

  moveToRight(): void {
    this.doMoveRight();
    this.refreshTrees();
  }

  moveAllToRight(): void {
    this.leftTree.selectAll();
    this.doMoveRight();
    this.refreshTrees();
    this.leftTree.unselectAll();
    this.rightTree.collapseAll();
  }

  private doMoveLeft(): void {
    const idKey = this.rightTree.idKey;
    const selectedNodes = this.rightTree.getSelectedNodes();
    selectedNodes.forEach(n => {
      const path = this.rightTree.getPath(n[idKey]);
      path.forEach(id => {
        const node = this.rightTree.getNodeById(id);
        const parentNode = this.rightTree.getParentById(id);
        const newNode = this.leftTree.addNode(node, parentNode?.[idKey], {skipChildNodes: true, emitEvent: false});
        if (newNode && !Array.isArray(newNode.children)) {
          this.rightTree.deleteNodeById(newNode[idKey], {emitEvent: false});
        }
      });
    });
  }

  private doMoveRight(): void {
    const idKey = this.leftTree.idKey;
    const t = this.leftTree.getSelectedNodes();
    t.forEach(n => {
      const path = this.leftTree.getPath(n[idKey]);
      path.forEach(id => {
        const node = this.leftTree.getNodeById(id);
        const parentNode = this.leftTree.getParentById(id);
        const newNode = this.rightTree.addNode(node, parentNode?.[idKey], {skipChildNodes: true, emitEvent: false});
        if (newNode && !Array.isArray(newNode.children)) {
          this.leftTree.deleteNodeById(newNode[idKey], {emitEvent: false});
        }
      });
    });
  }

  refreshTrees() {
    this.leftTree.refresh();
    this.rightTree.refresh();
  }

}
